import { Suspense, useEffect, useState } from "react";

import { getCurrentScreen } from "@auth0/auth0-acul-js";

import { getScreenComponent } from "@/utils/screen/screenLoader";

import { Loading } from "./screens/loading/Loading";

const App = () => {
  const [screen, setScreen] = useState("login-id");

  useEffect(() => {
    const current = getCurrentScreen();
    setScreen(current || "login-id");
  }, []);

  const ScreenComponent = getScreenComponent(screen);

  return (
    <Suspense fallback={<Loading />}>
      {ScreenComponent ? (
        <ScreenComponent />
      ) : (
        <div>Screen &quot;{screen}&quot; not implemented yet</div>
      )}
    </Suspense>
  );
};

export default App;
